module.exports = __webpack_public_path__ + "img/img81.b3129aeb.png";